import { cloneElement, type ReactElement, type ReactNode } from 'react'

import type { TMediumCommunityApi } from '@/src/features/community/api/communityApi.types'
import { useUserProfileModalContext } from '@/src/general/components/UserProfileModalContext/UserProfileModalContext'

import type { TUserProfilePreviewAvatarProps } from '../UserProfilePreview/UserProfilePreview'

export type TUserProfileWithModalProps = Pick<TMediumCommunityApi, 'user'> & {
  children: ReactElement<TUserProfilePreviewAvatarProps>
}

export const UserProfileWithModal = ({ user, children }: TUserProfileWithModalProps): ReactNode => {
  const { openUserProfileModal } = useUserProfileModalContext()

  return cloneElement(children, { onPress: () => openUserProfileModal(user) })
}
